export const CONFIRM_SIGN_IN_WITH_NEW_PASSWORD_REQUIRED =
    'CONFIRM_SIGN_IN_WITH_NEW_PASSWORD_REQUIRED';
export const CONTINUE_SIGN_IN_WITH_TOTP_SETUP =
    'CONTINUE_SIGN_IN_WITH_TOTP_SETUP';
export const CONFIRM_SIGN_IN_WITH_TOTP_CODE = 'CONFIRM_SIGN_IN_WITH_TOTP_CODE';
export const CONFIRM_RESET_PASSWORD_WITH_CODE =
    'CONFIRM_RESET_PASSWORD_WITH_CODE';
export const DONE = 'DONE';
